import React, { Component } from "react";
import { motion } from "framer-motion";
import "../styles/detalle70.css";

class Detalle70 extends Component {

  documentos = [
    {
      titulo: "Designación de Personas Consejeras",
      archivo: "/PDF/Consejeros/Consejeros.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Pronunciamiento de la Directora General",
      archivo: "/PDF/Consejeros/PRONUNCIAMIENTO_PROTOCOLO_CERO.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Informe Anual 2024",
      archivo: "/PDF/Consejeros/Informe_Anual_2024.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Informe Anual 2025",
      archivo: "/PDF/Consejeros/Informe_Anual_2025.pdf",
      miniatura: "/images/pdf-thumb.png"
    }
  ];

  renderCard = (doc, index) => {
    return (
      <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
        <motion.div
          className="pdf-card"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="pdf-thumb">
            <img src={doc.miniatura} alt="PDF" />
          </div>

          <h3 className="pdf-title">{doc.titulo}</h3>

          <a
            href={doc.archivo}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-btn"
          >
            Ver PDF
          </a>
        </motion.div>
      </div>
    );
  };

  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Protocolo Cero</h2>
          </header>

          <div className="row">
            {this.documentos.map(this.renderCard)}
          </div>
        </div>
      </div>
    );
  }
}

export default Detalle70;
